import {
  LOGIN,
  LOGIN_DONE,
  LOGIN_ERROR,
  CREATE_ACCOUNT,
  CREATE_ACCOUNT_DONE,
  CREATE_ACCOUNT_ERROR,
  EDIT_ACCOUNT,
  EDIT_ACCOUNT_DONE,
  EDIT_ACCOUNT_ERROR,
  LOGOUT,
  GET_ACCOUNT_DONE,
  GET_ACCOUNT_BY_ACCOUNT_ID,
  STORE_NEXT_URL,
  FETCH_AUTHORIZED_EVENT_DONE,
  FETCH_USER_PURCHASES_DONE,
  FETCH_ORDER_DETAILS_DONE,
  REQUEST_PASSWORD_RESET,
  REQUEST_PASSWORD_RESET_DONE,
  REQUEST_PASSWORD_RESET_ERROR,
  VERIFY_ACCOUNT_TOKEN,
  VERIFY_ACCOUNT_TOKEN_DONE,
  VERIFY_ACCOUNT_TOKEN_ERROR,
  RESET_ACCOUNT_PASSWORD,
  RESET_ACCOUNT_PASSWORD_DONE,
  RESET_ACCOUNT_PASSWORD_ERROR,
  CLEAN_NEXT_URL,
  CLEAR_AUTHORIZED_EVENT,
  CLEAR_ORDER_HISTORY,
  CLEAR_ORDER_DETAILS
} from "./constants";
import { removeItemFromLS } from "../../utils/util";
import Axios from "../../utils/axios";

const initialState = {
  user: {},
  authorizedEventAccess: {},
  loggedIn: false,
  isLoading: false,
  isSubmitting: false,
  nextUrl: "",
  errorLogin: false,
  purchases: null,
  orderDetails: null,
  tokenError: "",
  message: ""
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_ACCOUNT_BY_ACCOUNT_ID: {
      return { ...state, loggedIn: false, errorLogin: false, isLoading: true };
    }
    case LOGIN:
      return {
        ...state,
        isLoading: true,
        errorLogin: false,
        isSubmitting: true
      };
    case LOGOUT: {
      Axios.setAuthToken(false);
      removeItemFromLS("userId");
      return {
        ...initialState,
        nextUrl: state.nextUrl || ""
      };
    }
    case CREATE_ACCOUNT:
    case EDIT_ACCOUNT:
    case REQUEST_PASSWORD_RESET:
      return { ...state, isSubmitting: true };
    case RESET_ACCOUNT_PASSWORD:
      return { ...state, isSubmitting: true, tokenError: "", message: "" };
    case VERIFY_ACCOUNT_TOKEN:
      return { ...state, isLoading: true, tokenError: "" };
    case STORE_NEXT_URL:
      return { ...state, nextUrl: payload };
    case GET_ACCOUNT_DONE:
      return {
        ...state,
        user: { ...state.user, ...payload },
        isLoading: false,
        loggedIn: true,
        errorLogin: false
      };
    case LOGIN_DONE:
      return {
        ...state,
        user: { ...state.user, ...payload },
        loggedIn: true,
        isLoading: false,
        errorLogin: false,
        isSubmitting: false
      };
    case EDIT_ACCOUNT_DONE:
      return {
        ...state,
        user: { ...state.user, ...payload },
        isSubmitting: false
      };
    case CREATE_ACCOUNT_DONE:
    case REQUEST_PASSWORD_RESET_DONE:
      return { ...state, isSubmitting: false };
    case FETCH_AUTHORIZED_EVENT_DONE:
      return {
        ...state,
        authorizedEventAccess: {
          ...payload
        }
      };
    case FETCH_USER_PURCHASES_DONE:
      return {
        ...state,
        purchases: payload
      };
    case FETCH_ORDER_DETAILS_DONE:
      return {
        ...state,
        orderDetails: payload
      };
    case RESET_ACCOUNT_PASSWORD_DONE: {
      let error = "";
      let success = "";
      if (payload?.success) {
        success = payload.message;
      } else {
        error = `${payload?.message} Please try resetting your password again.`;
      }
      return {
        ...state,
        isSubmitting: false,
        tokenError: error,
        message: success
      };
    }
    case VERIFY_ACCOUNT_TOKEN_DONE: {
      const error = payload?.success
        ? ""
        : `${payload?.message} Please try resetting your password again.`;
      return { ...state, isLoading: false, tokenError: error };
    }
    case LOGIN_ERROR:
      return {
        ...state,
        loggedIn: false,
        errorLogin: true,
        isLoading: false,
        isSubmitting: false
      };
    case CREATE_ACCOUNT_ERROR:
    case EDIT_ACCOUNT_ERROR:
    case REQUEST_PASSWORD_RESET_ERROR:
      return {
        ...state,
        isSubmitting: false
      };
    case RESET_ACCOUNT_PASSWORD_ERROR: {
      const error =
        payload && (payload?.status === 400 || payload?.status === 404)
          ? "Unable to find account, please try resetting your password again."
          : "Unexpected error occurred.";
      return { ...state, isSubmitting: false, tokenError: error, message: "" };
    }
    case VERIFY_ACCOUNT_TOKEN_ERROR: {
      const error =
        payload && (payload?.status === 400 || payload?.status === 404)
          ? "Unable to find account, please try resetting your password again."
          : "Unexpected error occurred.";
      return { ...state, isLoading: false, tokenError: error };
    }
    case CLEAN_NEXT_URL:
      return { ...state, nextUrl: "" };
    case CLEAR_AUTHORIZED_EVENT:
      return {
        ...state,
        authorizedEventAccess: initialState.authorizedEventAccess
      };
    case CLEAR_ORDER_HISTORY:
      return {
        ...state,
        purchases: null
      };
    case CLEAR_ORDER_DETAILS:
      return {
        ...state,
        orderDetails: null
      };
    default:
      return state;
  }
};
